/* eslint-disable */
import { useMemo, useState, useEffect, useRef, React } from "react";
import GolferApi from "../../services/golfer-api";
import { Centrifuge } from "centrifuge";
import JoinChallengeInfoModal from "../../shared/components/modals/JoinChallengeInfoModal"
import JoinedChallengeModal from "../../shared/components/modals/JoinedChallengeModal"
import { Star, StarOutline } from "@mui/icons-material";
import { store } from "../../shared/store";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import ChallengeLeaderboardFilter from "./ChallengeLeaderboardFilter";

export default function Leaderboard() {
  const [currentUser, setCurrentUser] = useState(false);
  const [localStorageToken, setLocalStorageToken] = useState(null);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [joinedChallengeModalOpen, setJoinedChallengeModalOpen] =
    useState(false);
  const [userProgress, setUserProgress] = useState("");
  const [progressInfo, setProgressInfo] = useState("");
  const [challengeInfo, setChallengeInfo] = useState(null);
  const [joinedChallenge, setJoinedChallenge] = useState(false);
  const [topScores, setTopScores] = useState([]);
  const [totalScore, setTotalScore] = useState("");
  const centrifugeRef = useRef(null);
  const subRef = useRef(null);
  const pageRef = useRef(1);
  const [userName, setUserName] = useState(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [perPage, setPerPage] = useState(20); // Load 20 rows initially
  const [preview, setPreview] = useState(false);
  const [challengeName, setChallengeName] = useState("");
  const [daysLeft, setDaysLeft] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [isFollowingChecked, setIsFollowingChecked] = useState(false); // Following checkbox state
  const [selectedFilters, setSelectedFilters] = useState([]); // Array to hold applied filters
  const handleResize = () => setIsSmallScreen(window.innerWidth < 600);

  const userRowRef = useRef(null);
  const [isRowPinned, setIsRowPinned] = useState(true);
  const tableContainerRef = useRef(null);
  const computed_name =
    currentUser && isSmallScreen
      ? "GOLFER (H.I.)"
      : !currentUser
      ? "GOLFER"
      : "GOLFER (HANDICAP INDEX)";

  const getPrivateToken = async (pageNo) => {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];
    const response = await GolferApi.getPrivateLeaderboardToken(
      pageNo,
      idFromUrl
    );
    console.log(response.data.token);
    return response.data.token;
  };

  const getToken = async () => {
    const response = await GolferApi.getLeaderboardToken();
    return response.data.token;
  };

  useEffect(() => {
    const token = localStorage.getItem("ghin-user-token");
    setLocalStorageToken(token);
  }, []);

  const ws_connection = (pageNo = 0) => {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];

    const init = async () => {
      centrifugeRef.current = new Centrifuge(
        process.env.REACT_APP_CENTRIFUGO_URL,
        {
          getToken: getToken,
        }
      );
      centrifugeRef.current.connect();
    };
    init();
    centrifugeRef.current
      .on("connecting", function (ctx) {
        console.log(`connecting: ${ctx.code}, ${ctx.reason}`);
      })
      .on("connected", function (ctx) {
        console.log(`connected over ${ctx.transport}`);
      })
      .on("disconnected", function (ctx) {
        console.log(`disconnected: ${ctx.code}, ${ctx.reason}`);
      })
      .on("unsubscribed", function (ctx) {
        console.log("unsubscribed from server-side channel", ctx.channel);
      })
      .connect();
    if (userName) {
      subRef.current = centrifugeRef.current.newSubscription(
        "$leaderboard:" + idFromUrl + ":private",
        { getToken: () => getPrivateToken(pageNo) }
      );
      centrifugeRef.current
        .presence("$leaderboard:" + idFromUrl + ":private")
        .then(
          function (resp) {
            console.log(resp);
          },
          function (err) {
            console.log("presence error", err);
          }
        );
    } else {
      subRef.current = centrifugeRef.current.newSubscription(
        "leaderboard:" + idFromUrl + ":public"
      );
      centrifugeRef.current
        .presence("leaderboard:" + idFromUrl + ":public")
        .then(
          function (resp) {
            console.log(resp);
          },
          function (err) {
            console.log("presence error", err);
          }
        );
    }
    subRef.current
      .on("publication", function (ctx) {
        getData();
      })
      .on("subscribing", function (ctx) {
        console.log(`subscribing: ${ctx.code}, ${ctx.reason}`);
      })
      .on("subscribed", function (ctx) {
        console.log("subscribed", ctx);
      })
      .on("unsubscribed", function (ctx) {
        console.log(`unsubscribed: ${ctx.code}, ${ctx.reason}`);
      })
      .subscribe();
  };

  const closeModal = () => {
    setInfoModalOpen(false);
  };

  useEffect(() => {
    // ws_connection(0);
    // return () => {
    //   if (centrifuge) {
    //     centrifuge.disconnect();
    //   }
    // };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("per_page")) {
      setPerPage(params.get("per_page"));
    }

    if (params.has("preview")) {
      setPreview(params.get("preview"));
    }
    getData();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedStatus, isFollowingChecked, selectedFilters, page, perPage]);

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
    updateSelectedFilters("Status", value); // Update chips with selected status
  };

  const handleFollowingChange = () => {
    const newValue = !isFollowingChecked;
    setIsFollowingChecked(newValue);
    updateSelectedFilters("Following", newValue ? "Following" : ""); // Update chips with Following status
  };

  const updateSelectedFilters = (type, value) => {
    // Add or remove filter chips based on selections
    setSelectedFilters((prevFilters) => {
      const updatedFilters = prevFilters.filter(
        (filter) => filter.type !== type
      );
      if (value) {
        updatedFilters.push({ type, value });
      }
      return updatedFilters;
    });
  };

  useEffect(() => {
    if (!isRowPinned && userRowRef.current && tableContainerRef.current) {
      // Scroll the user row into view (its natural position in the table body)
      userRowRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      // Attach a scroll event listener to re-pin once the user scrolls.
      const container = tableContainerRef.current;
      const handleScroll = () => {
        setIsRowPinned(true);
        container.removeEventListener("scroll", handleScroll);
      };
      container.addEventListener("scroll", handleScroll);

      // Fallback: re-pin after 1 second if no scroll event occurs.
      const timeoutId = setTimeout(() => {
        setIsRowPinned(true);
        container.removeEventListener("scroll", handleScroll);
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [isRowPinned]);

  const getData = () => {
    let status =
      selectedStatus === "All Golfers"
        ? "all"
        : selectedStatus === "In-Progress"
        ? "in_progress"
        : selectedStatus.toLowerCase();

    const recordsToFetch = page * perPage;

    let params = {
      page: 1,
      per_page: recordsToFetch,
      status: status,
    };

    if (isFollowingChecked) params["following"] = true;

    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];
    let id = idFromUrl;

    var ghin_number = null;
    if (store.getState().authReducer.loginReducer.user)
      ghin_number = store.getState().authReducer.loginReducer.user.ghin_number;

    if (ghin_number)
      GolferApi.getGolferChallengeData(ghin_number)
        .then((res) => {
          if (res.data[0] && res.data[0].id == id) {
            setJoinedChallenge(true);
            setTopScores(res.data[0].top_3_scores);
            setUserProgress(res.data[0].progress);
            setTotalScore(res.data[0].total_net_score_to_par);
          }
        })
        .catch((err) => {
          console.log(err);
        });

    GolferApi.getChallengeData(id)
      .then((res) => {
        setChallengeInfo(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    GolferApi.getData(id, params)
      .then((res) => {
        if (res.data.mode) {
          setCurrentUser(res.data.current_user);
          setUserName(res.data.username);
        }

        let leaderboardData = res.data.leaderboard;

        if (res.data.current_user) {
          const uniqueData = [];
          const seen = new Set();

          leaderboardData.forEach((item) => {
            // Skip duplicates of current user except for the first occurrence
            if (item.ghin_number === res.data.current_user) {
              if (!seen.has(item.ghin_number)) {
                seen.add(item.ghin_number);
                uniqueData.push(item);
              }
            } else {
              uniqueData.push(item);
            }
          });

          leaderboardData = uniqueData;
        }

        setData(leaderboardData);
        setChallengeName(res.data.name);
        setDaysLeft(res.data.days_left);
        setPages(parseInt(res.headers["total-count"] , 10) / (perPage || 1));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLoadMore = () => {
    // centrifugeRef.current.removeSubscription(subRef.current);
    // ws_connection(page + 1);
    pageRef.current += 1;
    setPage(page + 1);
  };

  const handlePinnedRowClick = () => {
    setIsRowPinned(false);
  };

  const tabelHeightCalc = () => {
    if (preview) return 0;
    if (isFollowingChecked === false && selectedStatus === "all") return 134;
    return 166;
  };

  const rowPinningState =
    userName && data.some((row) => row.name === userName) && isRowPinned
      ? { top: [userName] }
      : { top: [] };

  const columns = useMemo(() => {
    const round_size = isSmallScreen ? 35 : 70;
    const position_size = isSmallScreen ? 35 : 90;
    const baseColumns = [
      {
        accessorKey: "position",
        header: isSmallScreen ? "POS" : "POSITION",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        grow: false,
        size: position_size,
        Cell: ({ row }) => (
          <div className="row">
            <span className="position-cell" style={{ fontSize: "16px" }}>
              <div className="col is-1-of-2">
                {row.original.position_display}
              </div>
              {currentUser && !isSmallScreen && (
                <div className="col is-2-of-2">
                  {row.original.followed === true ? (
                    <Star className="icon-star" />
                  ) : (
                    <StarOutline className="icon-star-outline" />
                  )}
                </div>
              )}
            </span>
          </div>
        ),
        muiTableHeadCellProps: { className: "header-position" },
        muiTableBodyCellProps: { className: "body-position" },
      },
      {
        accessorKey: "name",
        header: computed_name,
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: 120,
        Cell: ({ row }) => (
          <span className="name-cell">
            <span className="name-display">
              {row.original.short_name && isSmallScreen
                ? row.original.short_name
                : row.original.name}
            </span>
            {currentUser && (
              <span className="handicap-display">
                {row.original.hi_display}
              </span>
            )}
          </span>
        ),
        muiTableHeadCellProps: { className: "header-name" },
        muiTableBodyCellProps: { className: "body-name" },
      },
      {
        accessorKey: "r1",
        header: isSmallScreen ? "R1" : "RD1",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r1}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "500",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "r2",
        header: isSmallScreen ? "R2" : "RD2",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r2}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "500",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "r3",
        header: isSmallScreen ? "R3" : "RD3",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r3}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "500",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "total",
        header: isSmallScreen ? "Total" : "TOTAL",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span
            className={
              row.original.total?.includes("-")
                ? "total-negative"
                : "total-positive"
            }
            style={{ fontWeight: "100", fontFamily: "National Narrow Bold" }}
          >
            {row.original.total}
          </span>
        ),
        muiTableHeadCellProps: {
          className: "header-total",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "700",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: {
          className: "body-total",
          sx: {},
        },
      },
    ];
    // If no current user, reorder columns.
    if (!currentUser) {
      return [
        baseColumns[0], // position
        baseColumns[1], // name
        baseColumns[5], // total
        baseColumns[2], // r1
        baseColumns[3], // r2
        baseColumns[4], // r3
      ];
    }
    // Default order when current user exists.
    return baseColumns;
  }, [isSmallScreen, currentUser, computed_name]);

  // Create the table instance.
  const table = useMaterialReactTable({
    columns,
    data,
    layoutMode: "grid",
    defaultColumn: { minSize: 35 },
    enablePagination: false,
    enableBottomToolbar: false,
    enableStickyHeader: true,
    getRowId: (row) => row.name,
    initialState: {
      density: "compact",
      expanded: true,
    },
    state: { rowPinning: rowPinningState },
    enableColumnFilterModes: false,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    muiTableHeadRowProps: {
      sx: { boxShadow: "none" },
    },
    muiTablePaperProps: {
      sx: { boxShadow: "none" },
    },
    muiTableBodyRowProps: ({ row }) => {
      const isCurrentUserRow = row.id === userName;
      return {
        sx: {
          height: isSmallScreen ? "43px" : "77px",
          bottom: 0,
          top: isCurrentUserRow ? (isRowPinned ? "34px" : 0) : 0,
          zIndex: isCurrentUserRow ? 2 : 0,
          position: isCurrentUserRow
            ? isRowPinned
              ? "sticky"
              : "relative"
            : "relative",
          backgroundColor: isCurrentUserRow ? "rgb(237, 243, 247)" : undefined,
          cursor: isCurrentUserRow && isRowPinned ? "pointer" : "default",
        },
        onClick:
          isCurrentUserRow && isRowPinned ? handlePinnedRowClick : undefined,
        ref: !isRowPinned && isCurrentUserRow ? userRowRef : undefined,
      };
    },
    muiTableContainerProps: {
      ref: tableContainerRef,
      sx: {
        height: `calc(100vh - ${tabelHeightCalc()}px)`,
        position: "relative",
        padding: "0 10px",
        "@media (max-width: 600px)": {
          maxWidth: "100%",
          overflowX: "auto",
          fontSize: "6px",
        },
        "@media (min-width: 601px)": {
          maxWidth: "100%",
          fontSize: "10px",
        },
      },
    },
  });
  return (
    <div className="challenge-page-container">
      <div className="challenges-page-header">{challengeName}</div>
      {!preview && (
        <div className="challenge-content on-header">
          {/* Leaderboard Section */}
          <div className="leaderboard-container">
            {/* Leaderboard Table */}
            <div className="white-rectangle">
              <div className="leaderboard-header">
                <div className="challenge-leaderboard-title on-header">
                  Leaderboard
                </div>
                {currentUser && (
                  <ChallengeLeaderboardFilter
                    isFollowingChecked={isFollowingChecked}
                    handleFollowingChange={handleFollowingChange}
                    selectedStatus={selectedStatus}
                    handleStatusChange={handleStatusChange}
                  />
                )}
              </div>

              <MaterialReactTable table={table} />
            </div>

            {/* Load More Button */}
            {page < pages && pages !== 1 && !preview && (
              <div className="load-more-row">
                <button className="btn outline blue" onClick={handleLoadMore}>
                  Load More
                </button>
              </div>
            )}
          </div>
          <JoinChallengeInfoModal
            isOpen={infoModalOpen}
            closeModal={closeModal}
          />
          <JoinedChallengeModal
            title={`You joined the ${challengeInfo?.name}`}
            content={progressInfo}
            challengeId={challengeInfo?.id}
            progress={userProgress}
            isOpen={joinedChallengeModalOpen}
            onConfirmModal={() => {
              setJoinedChallengeModalOpen(false);
            }}
            onCloseModal={() => {
              setJoinedChallengeModalOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
}
